export var setPage = (page) => {
	return {
		type: "SET_CURRENT_PAGE",
		page
	};
};

export var setRedirectTo = (redirectTo) => {
	return {
		type: "SET_REDIRECT_TO",
		redirectTo
	}
};


// WEBPACK FOOTER //
// ./src/actions/pageActions.js